import cx from "classnames";
import { getMentionAttrsFromDOM } from "./helpers";
export const createMentionNodeSpec = (isCurrentMember) => ({
    attrs: {
        id: {},
        application: {},
        title: {},
        prefix: {},
    },
    inline: true,
    group: "inline",
    selectable: false,
    draggable: false,
    toDOM: (node) => {
        const attrs = node.attrs;
        const className = cx("mention", {
            "mention-current": isCurrentMember(attrs),
        });
        return [
            "a",
            {
                class: className,
                "mention-id": attrs.id,
                "mention-application-id": attrs.application.id,
                "mention-application-slug": attrs.application.slug,
                "mention-application-name": attrs.application.name,
                title: attrs.title,
            },
            `${attrs.prefix}${attrs.title}`,
        ];
    },
    parseDOM: [
        {
            tag: "a.mention",
            getAttrs: getMentionAttrsFromDOM,
        },
    ],
});
